import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const AdminMigrationApi = {
  reCalculateRaScores: async () =>
    await jwtAuthAxios().post<void>(`/admin/migrations/re-calculate-ra-scores`),
};
